import React from "react"

const ErrorPopUp = (props) => {
  // console.log(props);

  if (props.error && props.touched) {
    if (!props.type) {
      return <div className="required_validator visible" style={props.style ? props.style : {}}><div className="validator_container"><span>{'وارد کردن [' + props.error + '] الزامی است'}</span></div></div>;
    }
    else if (props.type === "select") {
      return <div className="required_validator visible" style={props.style ? props.style : {}}><div className="validator_container"><span>{'انتخاب [' + props.error + '] الزامی است'}</span></div></div>;
    }
    else if (props.type === "fullText") {
      return <div className="required_validator visible" style={props.style ? props.style : {}}><div className="validator_container"><span>{props.error}</span></div></div>;
    }
  }
  if (props.children) {
    if (!props.type) {
      return <div className="required_validator visible" style={props.style ? props.style : {}}><div className="validator_container"><span>{'وارد کردن [' + props.children + '] الزامی است'}</span></div></div>;
    }
    else if (props.type === "select") {
      return <div className="required_validator visible" style={props.style ? props.style : {}}><div className="validator_container"><span>{'انتخاب [' + props.children + '] الزامی است'}</span></div></div>;
    }
    else if (props.type === "fullText") {
      return <div className="required_validator visible" style={props.style ? props.style : {}}><div className="validator_container"><span>{props.children}</span></div></div>;
    }
  };
  return '';
};
export default ErrorPopUp;
